export default __webpack_public_path__ + "static/media/site-intranet.7ee78e25.png";